export default "__VITE_ASSET__ZsBPR7jQ__"